<template>
    <b-modal :title="$t('core.confirm')" :ref="_uid" @ok="confirm">
        {{ $t('core.areYouSure') }}
        <template v-slot:modal-footer="{ ok, cancel }">
            <b-button @click="cancel()">
                Cancel
            </b-button>
            <b-button @click="ok()" :name="okButtonName" variant="primary">
                {{ $t('core.yes') }}
            </b-button>
        </template>
    </b-modal>
</template>
<script>
export default {
    props: {
        okButtonName: { type: String, default: 'okButton' }
    },
    methods: {
        show() {
            this.$refs[this._uid].show();
        },
        confirm() {
            this.$emit('confirmAction');
        }
    }
};
</script>

<style></style>
